import { render, staticRenderFns } from "./UserRechargeAddress.vue?vue&type=template&id=687d2802&scoped=true&"
import script from "./UserRechargeAddress.vue?vue&type=script&lang=js&"
export * from "./UserRechargeAddress.vue?vue&type=script&lang=js&"
import style0 from "./UserRechargeAddress.vue?vue&type=style&index=0&id=687d2802&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d2802",
  null
  
)

export default component.exports